/* eslint-disable camelcase */

import { gql } from "@apollo/react-hooks";
import { CommandResult_Param } from "@graphql/helpers/types.graphql";
import { CommandResult } from "@graphql/groups/fragment.graphql";
import utils, { TNonEmptyArray, TParamType } from "@graphql/helpers/utils.graphql";

type TParamUpdateFunctions = {
  update: CommandResult_Param;
};

export type TParamUpdateMutations = {
  param: TParamUpdateFunctions;
};
export const paramUpdateMutation = (
  fields: TNonEmptyArray<TParamType>
) => gql`
  mutation paramUpdate($param: ParamUpdateInputType!) {
    param {
      update(param: $param) {
        ...COMMAND_RESULT
        result {
          ${utils.buildQuery(...fields)}
        }
      }
    }
  }
  ${CommandResult("CommandResult_Param")}
`;
